import {MetaTitleDesc} from "./meta";
import DocumentMeta from "react-document-meta";
import BlockLinkWithImg from "./BlockLinkWithImg";

export default () => {
    const title = 'События';

    const listEkses = [
        {
            imgFile: require('./img/events/openingbegin.jpg'),
            toLink: '/event-opening-begin',
            sub: 'Увековечение памяти Менахема Бегина'
        },
        {
            imgFile: require('./img/events/brestchinarelax2006.jpg'),
            toLink: '/event-brestchina-relax-2006',
            sub: 'Брестчина на выставке Отдых-2006'
        },
        {
            imgFile: require('./img/events/hodosy20041004.jpg'),
            outLink: 'http://brestobl.com/08zabin/pamjat/hodosy/index.html',
            sub: '4 октября 2004 г. Открытие мемориального памятника в урочище Ходосы'
        },
        {
            imgFile: require('./img/events/openingkostuszko.jpg'),
            outLink: 'http://brestobl.com/kostush/muzej.html',
            sub: '23 сентября 2004 г. Открытие каплицы (Чижевщина) и Дома-усадьбы Тадеуша Костюшко (Меречевщина)'
        },
        {
            imgFile: require('./img/events/begin.jpg'),
            outLink: 'http://brestobl.com/hist/ludi/begin.html',
            sub: 'Статья о Бегине'
        },
        {
            imgFile: require('./img/events/berestie2006.jpg'),
            outLink: 'http://brestobl.com/repor/300706.html',
            sub: 'Праздник города Берестье-2006'
        },
    ];

    let viewListEkses = listEkses.map((item, index) => {
            return (
                <BlockLinkWithImg
                    key = {index}
                    toLink = {item.toLink}
                    outLink = {item.outLink}
                    imgFile = {item.imgFile}
                    sub = {item.sub}
                />
            );
        }
    );

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    {viewListEkses}
                </div>
            </div>
        </>
    );
}